import { useSearchParams } from 'react-router-dom';
import { useWeekendHours } from '@/api/hooks/useDashboards';
import { WeekendAfterHoursCard } from '@/components/dashboards/WeekendAfterHoursCard';
import { parsePeriod } from '@/lib/timePeriod';

/**
 * Weekend / after-hours spend tile group — reads the page-level
 * `?period=` param (same convention as `HubKpiTiles`) so it stays in
 * sync with the Fraud Hub's `<TimePeriodSelector />`. Backed by
 * `GET /api/v1/dashboards/weekend-hours`.
 */
export function WeekendAfterHoursTiles(): JSX.Element {
  const [searchParams] = useSearchParams();
  const period = parsePeriod(searchParams.get('period'), 'M');
  const { data, isLoading, error } = useWeekendHours(period);

  return (
    <WeekendAfterHoursCard
      kpis={data?.kpis}
      isLoading={isLoading}
      error={(error as Error) ?? null}
    />
  );
}
